import { render, staticRenderFns } from "./Recipient.general.vue?vue&type=template&id=501bb6a4&"
import script from "./Recipient.general.vue?vue&type=script&lang=js&"
export * from "./Recipient.general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports